import type { QuizSteps } from "@/types/api.types";
import { useState } from "react";

const MultipleStepSelect = ({ step, onAnswer }: QuizSteps) => {
  const [selected, setSelected] = useState<string[]>([]);
  return (
    <div className="mx-auto max-w-md px-4 py-8">
      <h1 className="mb-6 text-center text-2xl font-bold text-gray-900">
        {step.title}
      </h1>
      <div className="flex flex-col gap-3">
        {step.options?.map((option) => (
          <button
            key={option.id}
            onClick={() => {
              if (selected.includes(option.value)) {
                setSelected(selected.filter((item) => item !== option.value));
              } else {
                setSelected([...selected, option.value]);
              }
            }}
            className={`w-full rounded-xl border p-4 text-left font-medium transition-all ${
              selected.includes(option.value)
                ? "border-blue-500 bg-blue-50 text-blue-700 shadow-sm ring-1 ring-blue-500"
                : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
      <br />
      <button
        disabled={selected.length === 0}
        onClick={() => onAnswer(selected)}
        className="mt-4 w-full rounded-xl bg-blue-600 px-6 py-3 font-semibold text-white transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500"
      >
        Continue
      </button>
    </div>
  );
};

export default MultipleStepSelect;
